module.exports = __webpack_public_path__ + "img/partners.7549f9e1.svg";